import { format } from "date-fns";

export const datePickerDateToUtc = (date) => {
  if (!date) return date;

  const stringDate = format(date, "yyyy-MM-dd");
  return `${stringDate}T00:00:00`;
};

export const formatUtcToDate = (date) => {
  if (!date) return date;

  const gtmDate = new Date(date);
  return format(gtmDate, "dd.MM.yyyy");
};

export const formatUtcToYYYYMMDDHH_24MMSS = (date) => {
  if (!date) return date;

  const gtmDate = new Date(date);
  return format(gtmDate, "yyyyMMdd_HHmmss");
};
export const formatUtcToTime = (date) => {
  if (!date) return date;

  const gtmDate = new Date(date);
  return format(gtmDate, "dd.MM.yyyy HH:mm:ss");
};

export function dateFormatter(cell, row) {
  return new Intl.DateTimeFormat("hr", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour12: false,
    timeZone: "Europe/Zagreb",
  }).format(new Date(cell));
}
